module.exports = __webpack_public_path__ + "static/media/sales-tech-pl.2613547e.svg";